import { useEffect, useState } from "react";
import api, { fmtDateTime } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquare, Send } from "lucide-react";

export function Chatter({ entityType, entityId }) {
  const [notes, setNotes] = useState([]);
  const [msg, setMsg] = useState("");

  const load = () => api.get(`/chatter/${entityType}/${entityId}`).then((r) => setNotes(r.data));
  useEffect(() => { if (entityId) load(); }, [entityId]);

  const send = async () => {
    if (!msg.trim()) return;
    await api.post(`/chatter/${entityType}/${entityId}`, { message: msg });
    setMsg("");
    load();
  };

  return (
    <div className="border border-border rounded-lg bg-white" data-testid="chatter-panel">
      <div className="px-4 py-3 border-b border-border flex items-center gap-2 font-heading font-semibold">
        <MessageSquare className="w-4 h-4" /> Notas internas
      </div>
      <div className="p-4 space-y-4 max-h-72 overflow-y-auto">
        {notes.length === 0 && <p className="text-sm text-muted-foreground">Sin notas todavía.</p>}
        {notes.map((n) => (
          <div key={n.id} className="flex gap-3" data-testid="chatter-note">
            <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground grid place-items-center text-xs font-semibold shrink-0">
              {n.user_name?.[0]?.toUpperCase()}
            </div>
            <div>
              <div className="text-sm"><span className="font-medium">{n.user_name}</span> <span className="text-xs text-muted-foreground">· {fmtDateTime(n.created_at)}</span></div>
              <div className="text-sm text-foreground/80">{n.message}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="p-4 border-t border-border flex gap-2">
        <Textarea value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Agregar nota, llamada o incidencia..." rows={2} data-testid="chatter-input" />
        <Button onClick={send} data-testid="chatter-send"><Send className="w-4 h-4" /></Button>
      </div>
    </div>
  );
}
